import React, { useState } from "react";

import { article, host } from "@Api";
const { fetchV3Articles } = article;
import { useDebounceEffect } from "ahooks";
import { Skeleton } from "antd";
import MoviesShortItem from "@Components/movie/MoviesShort/item";
import { initTracking } from "@Lib/jotai/tracking";
import { useAtom } from "jotai";
import LazyloadImage from "./lazyLoadImage";
import "@Styles/global.less";
import "@Styles/base.css";

const MoviePopover: React.FC<any> = (props) => {
  const { c } = host;
  const { isHoveringMovie, isMount } = props;

  const category = [
    {
      title: "為什麼要買",
      type: 3,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/為什麼要買`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273714164.png`,
    },
    {
      title: "車壇聊天室",
      type: 3,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/車壇聊天室`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273720251.png`,
    },
    {
      title: "買車小幫手",
      type: 3,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/買車小幫手`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273746689.png`,
    },
    {
      title: "超級測試",
      type: 3,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/超級測試`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273663424.png`,
    },
    {
      title: "該怎麼選",
      type: 3,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/該怎麼選`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273926087.png`,
    },
    {
      title: "60秒選車",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/60秒選車`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273754544.png`,
    },
    {
      title: "8891抓重點",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891抓重點`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273750257.png`,
    },
    {
      title: "8891超值選",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891超值選`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273863317.png`,
    },
    {
      title: "8891搶先試",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891搶先試`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273895845.png`,
    },
    {
      title: "8891爆新聞",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891爆新聞`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273924505.png`,
    },
    {
      title: "8891新發現",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891新發現`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273981103.png`,
    },
    {
      title: "8891現場直擊",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891現場直擊`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997273960882.png`,
    },
    {
      title: "8891聽質感",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891聽質感`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997274046223.png`,
    },
    {
      title: "8891買新車",
      type: 11,
      href: decodeURIComponent(encodeURIComponent(`${c}/movie/category/8891買新車`)),
      img: `https://photo.8891.com.tw/2024/08/07/1722997274078479.png`,
    },
  ];

  const [categoryIndex, setCategoryIndex] = useState(0);
  const [tracking] = useAtom(initTracking);
  const [data, setData] = useState([]);

  // useQuery会报错
  const fetchData = async () => {
    try {
      const res = await fetchV3Articles({
        limit: category[categoryIndex].type === 3 ? 1 : 2,
        contentType2: category[categoryIndex].title,
        type: category[categoryIndex].type,
      });
      if (res && res.status === 12000) {
        setData(res.data.list);
      }
    } catch (e) {}
  };

  // pref：优化
  useDebounceEffect(
    () => {
      fetchData();
    },
    [categoryIndex],
    {
      wait: 300,
    },
  );

  useDebounceEffect(
    () => {
      if (!isHoveringMovie) return;
      if (tracking) {
        tracking.trackEvent({
          name: "element_exposured",
          params: {
            page_business: "新車",
            trigger_id: "3299",
            page_id: "643",
            trigger_name: "欄目",
            next_spm: "2.643.585.1548",
            page: "全站導航",
            channel: "首頁",
            element_id: "欄目",
            element: "按鈕",
            module: "頂部導航",
            tracker_method: "config",
          },
        });
      }
    },
    [isHoveringMovie],
    {
      wait: 300,
    },
  );

  useDebounceEffect(
    () => {
      if (!isHoveringMovie || !data.length) return;
      if (tracking) {
        category[categoryIndex].type === 3
          ? tracking.trackEvent({
              name: "video_exposured",
              params: {
                page_business: "新車",
                trigger_id: "3301",
                page_id: "643",
                trigger_name: "影音",
                next_spm: "2.643.585.1549",
                page: "全站導航",
                channel: "首頁",
                element_id: "影音",
                element: "圖表",
                module: "頂部導航",
                tracker_method: "config",
              },
            })
          : data.find((_) => {
              tracking.trackEvent({
                name: "video_exposured",
                params: {
                  page_business: "新車",
                  trigger_id: "3303",
                  page_id: "643",
                  trigger_name: "短影音",
                  next_spm: "2.643.585.1550",
                  page: "全站導航",
                  channel: "首頁",
                  element_id: "短影音",
                  element: "圖表",
                  module: "頂部導航",
                  tracker_method: "config",
                },
              });
            });
      }
    },
    [isHoveringMovie, data],
    {
      wait: 300,
    },
  );

  const Item: React.FC<{ item: any }> = ({ item }) => {
    return (
      <a
        href={`/movies/${item.id}`}
        target='_blank'
        className={` w-[382px] inline-block relative`}
        data-title={category[categoryIndex].title}
        onClick={(e) => {
          e.stopPropagation();
          tracking.trackEvent({
            name: "video_clicked",
            params: {
              page_business: "新車",
              trigger_id: "3302",
              page_id: "643",
              trigger_name: "影音",
              next_spm: "2.643.585.1549",
              page: "全站導航",
              channel: "首頁",
              element_id: "影音",
              element: "圖表",
              module: "頂部導航",
              tracker_method: "config",
              expand: category[categoryIndex].title,
            },
          });
        }}
      >
        <div className={`relative w-full mb-20`}>
          <LazyloadImage src={item.thumb} alt='' style={{ width: "100%", height: "214px" }} Loaded={isMount} />
          <LazyloadImage
            src='https://photo.8891.com.tw/2023/08/15/1692090155275148.png'
            alt=''
            style={{ width: "32px", height: "40px" }}
            Loaded={isMount}
            className={`absolute left-0 top-0 bottom-0 right-0 m-auto`}
          />
        </div>
        <p className='text-[#333] text-16 leading-20 flex-1'>{item.title}</p>
      </a>
    );
  };

  return (
    <div
      className='absolute top-56 left-0 h-496 bg-[#fff] z-10000000 box-border pl-50 pt-20 flex nav-popover-shadow max-w-[1190px] min-w-[1190px] w-[1190px]'
      style={{
        boxShadow: "2px 6px 10px rgba(0,0,0,0.10)",
      }}
    >
      <div className='relative mr-50'>
        <h3 className='text-20 leading-20 text-[#333] font-medium mb-20'>熱門欄目</h3>

        <ul
          className='border-0 border-r-1 border-solid border-[#e8e8e8] w-[650px] grid text-14 mt-0 gap-20'
          style={{ gridTemplateColumns: "repeat(4, 130px)" }}
          id='MoviePopoverCategoryList'
        >
          {category.map((item: any, index: number) => (
            <li
              key={index + 1}
              onMouseEnter={() => {
                if (categoryIndex !== index) {
                  setData([]);
                }
                setCategoryIndex(index);
              }}
            >
              <a
                className='text-[#333] text-decoration-line block w-fit'
                href={item.href}
                target='_blank'
                onClick={(e) => {
                  e.stopPropagation();
                  tracking.trackEvent({
                    name: "element_clicked",
                    params: {
                      page_business: "新車",
                      trigger_id: "3300",
                      page_id: "643",
                      trigger_name: "欄目",
                      next_spm: "2.643.585.1548",
                      page: "全站導航",
                      channel: "首頁",
                      element_id: "欄目",
                      element: "按鈕",
                      module: "頂部導航",
                      tracker_method: "config",
                      expand: item.title,
                    },
                  });
                }}
              >
                <LazyloadImage
                  src={item.img}
                  alt=''
                  style={{ width: "130px", height: "50px", marginBottom: "14px" }}
                  Loaded={isMount}
                />
                <p className='mb-0 text-14 leading-18 text-center font-black'>{item.title}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className='relative mr-50'>
        <div className='flex justify-between'>
          <h3 className='text-20 leading-20 text-[#333] font-medium mb-20'>
            《{category[categoryIndex].title}》最新影片
          </h3>
          <a href={`${c}/movies`} className='text-14 text-[#333] leading-20 font-normal'>
            查看全部
          </a>
        </div>
        <div className='flex'>
          <ul
            className='grid mb-0 gap-22'
            style={{
              gridTemplateColumns: `${category[categoryIndex].type === 3 ? "repeat(1, 382px)" : "repeat(2, 180px)"}`,
            }}
          >
            {data.length === 0 && <Skeleton.Image active style={{ width: "382px", height: "214px" }} />}
            {!!data?.length &&
              data.map((item: any) => (
                <li className='' key={item.id + ""}>
                  {category[categoryIndex].type === 3 ? (
                    <Item item={item} />
                  ) : (
                    <MoviesShortItem
                      data={item}
                      imgBoxCss={"w-180 h-240"}
                      isMount={isMount}
                      onClick={() => {
                        tracking.trackEvent({
                          name: "video_clicked",
                          params: {
                            page_business: "新車",
                            trigger_id: "3304",
                            page_id: "643",
                            trigger_name: "短影音",
                            next_spm: "2.643.585.1550",
                            page: "全站導航",
                            channel: "首頁",
                            element_id: "短影音",
                            element: "圖表",
                            module: "頂部導航",
                            tracker_method: "config",
                            expand: category[categoryIndex].title,
                          },
                        });
                      }}
                    />
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MoviePopover;
